module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_53-cf0e8baf255366aa23bf8e9267f3d1da.png";